import React from 'react';
import { useTranslation } from 'react-i18next';

import { Form, FormGenerator } from '@/shared/ui';
import { TFormMutation } from '@/shared/ui/Form';
import { FormFieldValues } from '@/shared/ui/FormGenerator';

import { enterPasswordTgPersonalFormDataSchema } from '../../model/schemas';
import { TConfirmPasswordFormData } from '../../model/types';

type EnterPasswordTgPersonalDialogProps = {
  onSubmit: (data: TConfirmPasswordFormData) => Promise<void>;
  mutation: TFormMutation<void>;
};

export const ENTER_PASSWORD_FORM_ID = 'enter-password-tg-personal-form';

const defaultValues = {
  password: '',
};

export const EnterPasswordTgPersonalForm = ({
  onSubmit,
  mutation,
}: EnterPasswordTgPersonalDialogProps) => {
  const { t } = useTranslation();

  const formScheme = [
    {
      name: 'password',
      label: t('common:inputs.password'),
      type: FormFieldValues.Password,
      inputProps: {
        placeholder: t('common:inputs.placeholders.password'),
      },
    },
  ];

  return (
    <Form
      id={ENTER_PASSWORD_FORM_ID}
      schema={enterPasswordTgPersonalFormDataSchema(t)}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      mode="onChange"
      mutation={mutation}
    >
      <FormGenerator formScheme={formScheme} />
    </Form>
  );
};
